import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reviewQueueKeys } from '@/features/case-reports/hooks';

import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useApproveCaseReport(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (reportId: string) => sessionsService.approveCaseReport(sessionId, reportId),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports', sessionId),
      });
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports-meta', sessionId),
      });
      // Approving (or routing-on from lead → chief) shifts the report's
      // reviewerId; the cross-session review queue must refresh so the
      // chief who just approved sees the entry leave their backlog (and
      // the next-stage chief, if routed, sees it appear).
      void qc.invalidateQueries({ queryKey: reviewQueueKeys.all });
    },
  });
}
